<template>
  <div>
    <EmptyBlock
      v-if="!attachments || !attachments.length"
      custom-class="mt-0 pa-10"
      data-qa="document-noData"
      :text="$t('Tenders.NoData')"/>
    <template
      v-else>
      <div
        class="text-left bold font-size--14">
        {{ $t('Application.PurchasingDocuments') }}
      </div>
      <sDivider class="mt-1"/>
      <DocumentList
        :attachments="attachments"
        can_delete
        :new-endpoints="true"
        small/>
    </template>
  </div>
</template>
<script>
import EmptyBlock from 'components/common/elements/EmptyBlock.vue'
import DocumentList from 'components/common/blocks/DocumentList.vue'

import { StorageFile } from '@/types/commonFile.js'

import FilesApi from '@/api/filesApi'
const files_api = new FilesApi()

export default {
  name: 'purchaseDocuments',
  methods: {
    async fetchAttachments() {
      files_api.getFileList(this.itemId, 'Purchasing')
        .then((res) => {
          const files = res.map((file) => {
            const fileConvert = {
              title: file.fileName,
              size: file.size,
              key: file.id,
              created: file.modifier.userName,
              ...file
            }
            return new StorageFile(this.itemId, fileConvert, 'Purchasing')
          })
          this.$emit('update:attachments', files.sort((a, b) => new Date(b.dateModified) - new Date(a.dateModified)))
        })
    },
  },
  async created() {
    if (!this.attachments) {
      this.fetchAttachments()
    }
  },
  components: {
    EmptyBlock,
    DocumentList
  },
  props: {
    itemId: Number,
    attachments: Array,
  },
}
</script>
